import { mixpanelTrack } from "./mixpanelTrack";

// Players (top-level hub) client-side Mixpanel events. Same shape as
// events/evolutionsMixpanel.ts but a distinct SECTION ("Players") and
// content_type "player". The shared toolbar/list components branch on their
// page-type prop to decide which section's track* fn to call.

const SECTION = "Players";

export type PlayersSubsection = "Overview" | "Player View";

export const trackViewContent = (params: {
  subsection: PlayersSubsection;
  new_content?: boolean;
}) => {
  mixpanelTrack("view_content", {
    section: SECTION,
    subsection: params.subsection,
    content_type: "player",
    new_content: params.new_content ?? false,
    action_type: "core",
  });
};

export const trackSort = (params: {
  subsection: PlayersSubsection;
  value: string;
}) => {
  const value = params.value === "date-added" ? "new" : params.value;
  mixpanelTrack("sort", {
    section: SECTION,
    subsection: params.subsection,
    value,
    action_type: "browse",
  });
};

export const trackFilter = (params: {
  subsection: PlayersSubsection;
  filters: string[];
}) =>
  mixpanelTrack("filter", {
    section: SECTION,
    subsection: params.subsection,
    filters: params.filters,
    action_type: "browse",
  });

export const trackQuickFilter = (params: {
  subsection: PlayersSubsection;
  filters: string;
}) =>
  mixpanelTrack("quick_filter", {
    section: SECTION,
    subsection: params.subsection,
    filters: params.filters,
    action_type: "browse",
  });

export const trackShare = (params: { subsection: PlayersSubsection }) =>
  mixpanelTrack("share", {
    section: SECTION,
    subsection: params.subsection,
    content_type: "player",
    action_type: "community",
  });

export const trackAddedPlayerToEvolutionBuilder = (params: {
  subsection: PlayersSubsection;
}) =>
  mixpanelTrack("added_player_to_evolution_builder", {
    section: SECTION,
    subsection: params.subsection,
    action_type: "browse",
  });
